import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationMessageComponent } from '../components/notification-message';

@Injectable({
  providedIn: 'root'
})
export class NotificationMessageService {

  constructor(
    private snackBar: MatSnackBar,
    ) { }

  openBarMessage(message: string, type?: any) {
    const durationInSeconds = 5;

    this.snackBar.openFromComponent(NotificationMessageComponent, {
      data: {message, type},
      panelClass: type.class,
      duration: durationInSeconds * 1000
    });

  }

  closeBarMessage(){
    this.snackBar.dismiss();
  }


}
